module.exports = __webpack_public_path__ + "img/forum_off.b47224dc.svg";